import { useQuery } from "react-query";
import { getCarrierAgreementsReport } from "../../../../../actions/CarrierAgreementMgmt/Reports";

export const useCarrierAgreementReport = () => {
  return useQuery(
    ["getCarrierAgreementReport"],
    () => getCarrierAgreementsReport(),
    {
      refetchOnWindowFocus: false,
    }
  );
};
